<template>
  <div @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div >Ethnic Diversity</div>
    <div>
      <div v-if="active">
        <apexchart width="400" type="donut" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div v-else class="content">
        <img src="../assets/campus.jpg">
        <div class="text"><h1>Ethnic Diversity</h1></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
   return {
    active: false,
    //image: { 'backgroundImage: "url(https://vuejs.org/images/logo.png)"': active },
    series: [79.5, 17.8, 1.1, 1.1, 0.4, 0.2],
    chartOptions: {
      labels: ['Black or African American', 'Hispanic or Latino', 'White', 'Non-Resident Alien', 'American Indian or Alaskan Native','Other'],
      legend: {
        show: false
      },
      chart: {
        type: 'donut',
      },
        stroke: {
        colors: ['#fff']
      },
        fill: {
        opacity: 0.8
      },
        responsive: [{
          breakpoint: 480,
          options: {
          chart: {
            width: 200
          },
        }
      }]
    },
   }      
  },
  methods: {
    mouseOver: function() {
      this.active = true;
    }, 
    mouseLeave: function() {
      this.active = false;
    }
  },
};
</script>
<style scoped>
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

.content {
  text-align: center;
  position: relative;
}
</style>